export default "__VITE_ASSET__3243078a__"